<template>
  <div>
    <el-drawer
      v-if="visible"
      visible
      :title="title"
      direction="rtl"
      :size="753"
      :before-close="() => $refs.main.cancel()"
      @close="close()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          :tskRemarkCode="tskRemarkCode"
          :expoMeetingCode="expoMeetingCode"
          :tskInfoCode="tskInfoCode"
          :linkUserCodes="linkUserCodes"
          @close="close()"
          @reload="$emit('reload')"
        />
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ this.$l('btn_cancel') }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.main.save()"
        >
          {{ $l('btn_save') }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    tskRemarkCode: { type: String, default: '' },
    tskInfoCode: { type: String, default: '' },
    expoMeetingCode: { type: String, default: '' },
    linkUserCodes: { type: Array, default: [] },
  },
  computed: {
    disabled() {
      return ['detail', 'confirm'].includes(this.type)
    },
    titleMap() {
      return {
        add: this.$l('dialog_title_add_task_remark') || '新增任务备注',
        reply: this.$l('dialog_title_add_task_remark') || '新增任务备注',
        edit: this.$l('dialog_title_edit_task_remark') || '编辑任务备注',
      }
    },
    title() {
      return this.titleMap[this.type] || ''
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('reload')
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 32px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
